import { TemplateModel } from '@/components/ui';
import { FORMATTER_CLASSIFICATION_FUNCTION_ID } from '@/constants';
import { generateId } from '@/utils';

import {
  bicSwiftValidator,
  currencyFormatter,
  dateFormatter,
  emailValidator,
  freightContainerIdValidator,
  highConfidenceValidator,
  ibanValidator,
  licensePlateValidator,
  numericFormatter,
  passportNumberValidator,
  phoneNumberValidator,
  taxIdValidator,
  urlValidator,
  vatIdValidator,
} from './common.ts';

export const GENERIC: TemplateModel = {
  fields: [
    {
      id: generateId(),
      type: 'single-value',
      name: 'Text',
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'e.g. Vendor',
        promptHintPlaceholder: 'e.g. The name of the vendor or supplier',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Numeric',
      formatters: [numericFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'e.g. Total amount',
        promptHintPlaceholder: 'e.g. The total amount including taxes and fees',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Date',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: '.e.g. Due date',
        promptHintPlaceholder: '.e.g. The invoice due date',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Currency',
      formatters: [currencyFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: 'Currency',
        promptHintPlaceholder: 'e.g. The ISO currency',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Classification',
      formatters: [
        {
          id: generateId(),
          functionId: FORMATTER_CLASSIFICATION_FUNCTION_ID,
          name: 'Classification',
          description: 'Enforce one of the defined classes',
          config: {
            labels: [],
          },
        },
      ],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'e.g. Document type',
        promptHintPlaceholder: 'e.g. The type of document',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'IBAN',
      formatters: [],
      validators: [ibanValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'IBAN',
        namePlaceholder: 'e.g. IBAN Number',
        promptHintPlaceholder: 'e.g. The IBAN number',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'BIC/SWIFT',
      formatters: [],
      validators: [bicSwiftValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'BIC/SWIFT',
        namePlaceholder: 'e.g. BIC/SWIFT Code',
        promptHintPlaceholder: 'e.g. The BIC/SWIFT code',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'License Plate',
      formatters: [],
      validators: [licensePlateValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'License Plate',
        namePlaceholder: 'e.g. License Plate Number',
        promptHintPlaceholder: 'e.g. The vehicle license plate number',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Passport Number',
      formatters: [],
      validators: [passportNumberValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'Passport Number',
        namePlaceholder: 'e.g. Passport Number',
        promptHintPlaceholder: 'e.g. The passport number',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Phone Number',
      formatters: [],
      validators: [phoneNumberValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'Phone Number',
        namePlaceholder: 'e.g. Phone Number',
        promptHintPlaceholder: 'e.g. The phone number',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'VAT ID',
      formatters: [],
      validators: [vatIdValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'VAT ID',
        namePlaceholder: 'e.g. VAT ID',
        promptHintPlaceholder: 'e.g. The VAT ID',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Tax ID',
      formatters: [],
      validators: [taxIdValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'Tax ID',
        namePlaceholder: 'e.g. Tax ID',
        promptHintPlaceholder: 'e.g. The Tax ID',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Email',
      formatters: [],
      validators: [emailValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'Email',
        namePlaceholder: 'e.g. Email Address',
        promptHintPlaceholder: 'e.g. The email address',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Freight Container ID',
      formatters: [],
      validators: [freightContainerIdValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'Freight Container ID',
        namePlaceholder: 'e.g. Freight Container ID',
        promptHintPlaceholder: 'e.g. The Freight Container ID',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'URL',
      formatters: [],
      validators: [urlValidator, highConfidenceValidator],
      helpProps: {
        defaultName: 'URL',
        namePlaceholder: 'e.g. Website URL',
        promptHintPlaceholder: 'e.g. The URL',
      },
    },
  ],
  sampleDocuments: [],
};
